<template>
  <div class="container-fluid col-10 offset-1">
    <div v-for="(groups, groupname, index) in posters">
      <div class="alert alert-primary mb-1" v-on:click="setOpenCollapse('group' + index)">
        <button class="btn btn-link font-weight-bold collapsed" type="button" data-toggle="collapse"
                :data-target="'#group'+index"
                aria-expanded="false" :aria-controls="'group' + index">
          <span class="when-opened"> <icon :icon="['fad', 'chevron-down']"/> </span>
          <span class="when-closed"> <icon :icon="['fad', 'chevron-right']"/> </span>
          {{groupname}}
        </button>
      </div>
      <div class="card-deck collapse" :id="'group' + index">
        <Card :poster="poster" v-for="(poster) in groups"/>
      </div>
    </div>
  </div>
</template>

<script>
    import Card from "../items/Card";
    import {mapState} from 'vuex'

    const VueScrollTo = require('vue-scrollto');

    export default {
        data() {
            return {}
        },
        computed: {
            ...mapState(
                ['openCollapse']
            ),
        },
        props: ['posters'],
        name: "groupedCard",
        components: {Card},
        methods: {
            setOpenCollapse: function (collapse) {
                this.$store.state.openCollapse = collapse;
            },
            scrollTo: function () {
                let scrollspeed = 500;
                if(this.$browserDetect.meta.name === 'Chrome') {
                    scrollspeed = 1500;
                }
                VueScrollTo.scrollTo('#poster' + this.$route.params.poster, scrollspeed, {easing: 'ease-in'});
            },
        },
        created() {
            if (!this.$store.state.ratings.length) {
                this.$store.dispatch('GET_ALL_RATINGS');
            }
        },
        mounted() {
            if (this.$store.state.openCollapse.length > 0) {
                $('#' + this.$store.state.openCollapse).collapse('show');
            }
            if (this.$route.params.poster > 0) {
                this.scrollTo();
            }
            this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'view/' + this.$store.state.mode.displayType, 'grouped:' + this.$store.state.mode.grouped.status);
        }
    }
</script>

<style scoped>
  @media (min-width: 10em) {
    .card-deck > .card {
      width: 30%;
      flex-wrap: wrap;
      flex: initial;
    }
  }

  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
</style>
